module.exports = __webpack_public_path__ + "fonts/Arimo-600-hebrew21.0d4611a.woff2";